export const MAGIC_NUMBER = {
  OTP_DIGITS: 6,
  TOAST_AUTO_HIDE_TIME: 30000,
  AUTOSUGGESTION_DELAY: 350,
  MAX_PHONE_DIGITS: 15,
  MIN_PHONE_DIGITS: 10,
  MAX_GUESTS: 16,
  MAX_ROOMS: 10,
  MIN_DISTANCE: 1,
  MAX_DISTANCE: 50,
  MIN_PRICE: 0,
  MAX_PRICE: 5000,
  OTP_RESEND_WAIT: 30,
  BANNER_CHANGE_DELAY: 3000,
  FEATURED_LISTING_CHANGE_DELAY: 2500,
  US_CENTER: [39.8283, -98.5795],
  DEFAULT_FEATURED_LISTING_RADIUS: 5,
  DEFAULT_FEATURED_LISTING_LATITUDE: 34.3647324,
  DEFAULT_FEATURED_LISTING_LONGITUDE: -89.5406317,
  FEATURED_LISTING_PAGE_SIZE: 4,
  DEFAULT_CHECK_IN_DATE_OFFSET: 1,
  DEFAULT_CHECK_OUT_DATE_OFFSET: 2,
  EXTENDED_STAY_MIN_DURATION: 7,
  WEEKEND_STAY_MIN_DURATION: 2,
  CHECK_IN_DATE_FORMAT: "M/dd/yyyy",
  CHECK_IN_DATE_FORMAT_MOMENT: "M/DD/YYYY",
  TOAST_HIDE_DELAY: 5000,
  REDIRECT_DELAY: 3000,
  QUICK_REDIRECT_DELAY: 1500,
  TEN:10,
  HUNDRED:100,
  TWOTHOUSAND:2000,
  FIVEHUNDRED:500,
  FIFTEENHUNDRED: 1500,

}

// this is used for  price range filter
export const priceSelectOption = [
  { value: "0-100", label: "Under $100" },
  { value: "100-200", label: "$100 - $200" },
  { value: "200-300", label: "$200 - $300" },
  { value: "300-500", label: "$300 - $500" },
  { value: "500-5000", label: "$500 and above" }
]
